module.exports = __webpack_public_path__ + "img/403-error.c09ace50.png";